var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.markets.length > 0)?_c('div',[_c('cv-banner-detail',{attrs:{"coin":_vm.coin}}),_vm._v(" "),_c('cv-market-list',{attrs:{"markets":_vm.markets}})],1):_c('cv-loader')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac816d3c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/coindetail.vue
// module id = 336
// module chunks = 0